module.exports = __webpack_public_path__ + "img/storm_session.e5799ca5.jpg";